import { append, assoc, assocPath } from 'ramda'

import { Addon } from '@ecm/data/Addon'
import Addresses, { Address } from '@ecm/data/Address'
import { Coupon } from '@ecm/data/Coupon'
import Plans, { Plan } from '@ecm/data/Plan'
import { partialValidator } from '@ecm/data/Validation'

type Cart_ = {
  plan: Plan
  addons: Addon[]
  addresses: Address[]
  coupon?: Coupon
}
export type Cart = Cart_ & {
  __Type: 'cart'
}

export const cart = (c: Cart_): Cart => ({
  ...c,
  __Type: 'cart',
})

const empty = (): Cart =>
  cart({
    addons: [],
    addresses: [Addresses.empty()],
    plan: Plans.empty(),
  })

const addAddon = (cart: Cart, addon: Addon): Cart => {
  const existingAddon = cart.addons.filter(a => a.slug === addon.slug)
  if (existingAddon[0]) {
    const newQuantity = existingAddon[0].canHaveMultiple
      ? existingAddon[0].quantity
        ? existingAddon[0].quantity + 1
        : 1
      : 1
    const newAddonsArray = cart.addons.map(a =>
      a.slug === addon.slug ? assoc('addon', newQuantity, a) : a
    )

    return assocPath(['addons'], newAddonsArray, cart)
  } else {
    return assocPath(['addons'], append(assocPath(['quanitity'], 1, addon), cart.addons), cart)
  }
}

const removeAddon = (cart: Cart, addon: Addon): Cart => {
  const remainingAddons = cart.addons.filter(a => a.slug !== addon.slug)
  return assocPath(['addons'], remainingAddons, cart)
}

export const isValidCart = (pCart: Partial<Cart>): boolean => {
  const cart = partialValidator<Cart>(pCart, empty(), 'CartValidation')
  if (!cart.plan.handle) {
    return false
  }
  if (cart.plan.restrictedAddress) {
    return cart.addresses.length === 1 && cart.addresses[0].slug === 'Beaverton_OR_STR_Gemini'
  } else {
    return cart.addresses.length >= 1
  }
}

export default {
  addAddon: addAddon,
  constructor: cart,
  empty: empty,
  isValidCart: isValidCart,
  removeAddon: removeAddon,
}
